import 'reflect-metadata'
import { injectable } from 'tsyringe'
import ProfileRepository from '@/repositories/ProfileRepository'
import SnapsnapGateway from '@/gateways/SnapsnapGateway'
import { ErrorType, UnauthorizedError } from '@/common/errors'
@injectable()
export default class LoginUseCase implements BaseUseCase {
  constructor(public profileRepository: ProfileRepository, public snapsnapGateway: SnapsnapGateway) {}

  async execute(params: { email: string; password: string; rememberMe?: boolean }) {
    try {
      const { profile } = await this.snapsnapGateway.login(params)
      this.profileRepository.saveProfile(profile)
    } catch (error) {
      if ('raw' in error && 'response' in error.raw && error.raw.response && error.raw.response.data && error.raw.response.data.message && error.raw.response.data.message.includes('inquiryNum')) {
        // ANCHOR: queryから{会員ID→最大7桁の数字 + 'Y'}を取得する。sliceで抽出しているためqueryの仕組みに変更があった際は確認が必要。
        const message = error.raw.response.data.message
        const indexOf = message.indexOf('inquiryNum=')
        const length = 'inquiryNum='.length
        const inquiryNum = message.slice(indexOf + length)

        // eslint-disable-next-line no-throw-literal
        throw {
          inquiryNum
        }
      }
      if (error.status === ErrorType.UNAUTHORIZED) {
        throw new UnauthorizedError('Authorization failed!')
      }
      throw error
    }
  }
}
